import { createRoute, createRouter, Navigate, RouterProvider } from "@tanstack/react-router";
import ContentFrame from "./components/ContentFrame";
import NotFound from "./components/NotFound";
import QueryProvider, { queryClient } from "./components/QueryProvider";
import { allTasksRoute } from "./routes/AllTasksRoute";
import { assignedToMeRoute } from "./routes/AssignedToMeRoute";
import { acceptInvitationRoute } from "./routes/acceptInvitationRoute";
import { adminUsersRoute } from "./routes/adminUsersRoute";
import { appRoute } from "./routes/appRoute";
import { createdByMeRoute } from "./routes/CreatedByMeRoute";
import { createTeamRoute } from "./routes/createTeamRoute";
import { forgotPasswordRoute } from "./routes/forgotPasswordRoute";
import { inboxRoute } from "./routes/inboxRoute";
import { joinTeamRoute } from "./routes/joinTeamRoute";
import { loginRoute } from "./routes/loginRoute";
import { oauthConsentRoute } from "./routes/oauthConsentRoute";
import { resetPasswordRoute } from "./routes/resetPasswordRoute";
import { rootRoute } from "./routes/rootRoute";
import { signupRoute } from "./routes/signupRoute";
import { taskListRoute } from "./routes/taskListRoute";

const indexRoute = createRoute({
    getParentRoute: () => appRoute,
    path: "/",
    component: () => <Navigate to={inboxRoute.to} />,
});

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}

// Extend the global Window interface
declare global {
    //interface Window extends OrsaneWindow {}
    const __APP_VERSION__: string;
}

const routeTree = rootRoute.addChildren([
    appRoute.addChildren([indexRoute, inboxRoute, taskListRoute, assignedToMeRoute, createdByMeRoute, allTasksRoute]),
    loginRoute,
    signupRoute,
    acceptInvitationRoute,
    createTeamRoute,
    joinTeamRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
    oauthConsentRoute,
    adminUsersRoute,
]);

const router = createRouter({
    routeTree,
    context: { queryClient },
    defaultNotFoundComponent: NotFound,
    defaultErrorComponent: import.meta.env.PROD
        ? () => {
              return (
                  <ContentFrame>
                      <div className="flex flex-col items-center justify-center h-full">
                          <div className="font-medium">Unexpected error</div>
                          <div>
                              Please refresh and try again or contact support at{" "}
                              <a className="underline" href="mailto:support@orsane.be">
                                  support@orsane.be
                              </a>
                              .
                          </div>
                      </div>
                  </ContentFrame>
              );
          }
        : undefined,
});

const App: React.FC = () => {
    return (
        <QueryProvider>
            <RouterProvider router={router} />
        </QueryProvider>
    );
};

export default App;
